module.exports = __webpack_public_path__ + "img/尊享星级卫浴.0f35bb80.webp";